import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = {
    secondsRemaining: Number,
    expiredUrl: String
  }

  connect() {
    this.remaining = this.secondsRemainingValue
    this.updateDisplay()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    this.remaining -= 1

    if (this.remaining <= 0) {
      clearInterval(this.timer)
      this.remaining = 0
      this.handleExpiry()
      return
    }

    this.updateDisplay()
    this.updateUrgency()
  }

  updateDisplay() {
    const minutes = Math.floor(this.remaining / 60)
    const seconds = this.remaining % 60
    const formatted = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`

    this.displayTargets.forEach(target => {
      target.textContent = formatted
    })
  }

  updateUrgency() {
    if (this.remaining <= 120) {
      this.element.classList.add("countdown-urgent")
    }
  }

  handleExpiry() {
    if (this.expiredUrlValue) {
      window.location.href = this.expiredUrlValue
    } else {
      this.displayTargets.forEach(target => {
        target.textContent = "00:00"
      })
      this.element.classList.add("countdown-expired")

      // Replace entire controller element content with expired message
      this.element.innerHTML = `
        <div class="text-center py-3">
          <i class="bi bi-clock-history" style="font-size: 1.5rem; color: #ef4444;"></i>
          <span class="ms-2 fw-bold" style="color: #ef4444;">Payment window has expired</span>
        </div>
      `
    }
  }
}
